/* eslint-disable react-hooks/exhaustive-deps */
import { NumberInput, Select } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import {
  useEffect, useMemo, useRef, useState,
} from "react";
import uuid from "react-uuid";

type Props = {
  handleChange: (
    operator: string,
    value: any,
    type: string,
    entityType: string,
    time_window: string,
  ) => void;
  fieldSelect: boolean;
  op?: string;
  value?: any;
  entity?: any;
  timeWindow: string;
};

const MetricFilter = (props: Props) => {
  const {
    op,
    value,
    handleChange,
    fieldSelect,
    entity,
    timeWindow,
  } = props;

  const Ops = useMemo(
    () => [
      {
        name: "is equal to", operator: "eq", id: 1, entityType: "changeval",
      },
      {
        name: "is not equal to", operator: "ne", id: 2, entityType: "changeval",
      },
      {
        name: "is greater than", operator: "gt", id: 3, entityType: "changeval",
      },
      {
        name: "is less than", operator: "lt", id: 4, entityType: "changeval",
      },
      {
        name: "is in range", operator: "range", id: 5, entityType: "changeval",
      },
      {
        name: "% change greater than", operator: "gt", id: 6, entityType: "growthval",
      },
      {
        name: "% change less than", operator: "lt", id: 7, entityType: "growthval",
      },
      {
        name: "% change in range", operator: "range", id: 8, entityType: "growthval",
      },
    ],
    [],
  );
  const firstRender = useRef(true);
  const [selectOp, setSelectOp] = useState<any>(Ops.find((item) => item.operator === op && item.entityType === entity) || null);
  const [firstVal, setFirstVal] = useState<any>(value?.start ? value.start
    : (value || 0));
  const [debouncedVal1] = useDebouncedValue(firstVal, 700);
  const [secondVal, setSecondVal] = useState<any>(value?.end || 0);
  const [debouncedVal2] = useDebouncedValue(secondVal, 700);

  useEffect(() => {
    if (!firstRender.current) {
      if (selectOp?.operator) {
        if (selectOp.operator !== "range" && (!!debouncedVal1 || debouncedVal1 === 0)) {
          handleChange(
            selectOp.operator,
            parseInt(debouncedVal1, 10),
            "int",
            selectOp.entityType,
            timeWindow,
          );
        } else if (selectOp.operator === "range" && (!!debouncedVal1 || debouncedVal1 === 0) && (!!debouncedVal2 || debouncedVal2 === 0)) {
          handleChange(
            selectOp.operator,
            {
              start: parseInt(debouncedVal1, 10),
              end: parseInt(debouncedVal2, 10),
            },
            "int",
            selectOp.entityType,
            timeWindow,
          );
        }
      }
    }
    firstRender.current = false;
  }, [debouncedVal1, debouncedVal2, selectOp, timeWindow]);

  // Convert operators to format expected by Mantine Select
  const operatorOptions = useMemo(() => 
    Ops.map(option => ({
      value: option.id.toString(),
      label: option.name
    })), 
    [Ops]
  );
  
  return (
    <>
      <Select
        disabled={fieldSelect}
        placeholder="Select Condition"
        data={operatorOptions}
        value={selectOp ? selectOp.id.toString() : null}
        onChange={(val) => {
          const selected = Ops.find(item => item.id.toString() === val);
          setSelectOp(selected || null);
        }}
        w={170}
      />
      <NumberInput
        disabled={!selectOp?.operator}
        placeholder="Enter number"
        id={uuid()}
        min={0}
        value={firstVal}
        onChange={setFirstVal}
      />
      {selectOp?.operator === "range" && (
        <NumberInput
          disabled={!selectOp?.operator}
          placeholder="Enter number"
          min={0}
          id={uuid()}
          value={secondVal}
          onChange={setSecondVal}
        />
      )}
    </>
  );
};

export default MetricFilter;
